import { useMediaQuery } from '@material-ui/core';
import { BREAKPOINTS } from '../theme/breakpoints';

/**
 * Única fuente de verdad para los breakpoints responsive en JS.
 * - useIsMobile():  true en teléfonos (ancho <= 600px)
 * - useIsCompact(): true en teléfonos y tablets verticales (ancho <= 960px)
 *
 * Se usan media queries en píxeles explícitos (no theme.breakpoints.down)
 * para evitar la ambigüedad de MUI v4, donde down('sm') significa < md (960px).
 */
export const useIsMobile = (): boolean =>
    useMediaQuery(`(max-width:${BREAKPOINTS.mobile}px)`);

export const useIsCompact = (): boolean =>
    useMediaQuery(`(max-width:${BREAKPOINTS.tablet}px)`);
